import { render, staticRenderFns } from "./ConservationValuesCard.vue?vue&type=template&id=44aad0f2&title=Conservation%20Purposes%20Statement"
import script from "./ConservationValuesCard.vue?vue&type=script&lang=js"
export * from "./ConservationValuesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports